module.exports = __webpack_public_path__ + "static/media/Odette_for_CR_book_ref.19fb4e0a.JPG";